import React from 'react'

/*
 * FloatingContactButtons
 *
 * Bottom-right pair of always-on contact shortcuts: one opens
 * WhatsApp with AUMHUM's number, the other opens the ContactTeamModal
 * via the `onPhoneClick` callback from the page-level container.
 *
 * Both buttons are rendered as a vertical stack so they adapt cleanly
 * on tight mobile widths. Positioning uses a CSS variable
 * (`--ct-floating-bottom`) so pages that already have a bottom bar
 * (e.g. the mentor landing page's "Request a session" strip) can lift
 * the buttons higher without touching JS.
 */

export default function FloatingContactButtons({ contact, onPhoneClick }) {
  const whatsappHref = contact?.whatsappHref || 'https://wa.me/916360903465'
  return (
    <div className="ct-floating" role="group" aria-label="Quick contact">
      <a
        href={whatsappHref}
        className="ct-floating-btn ct-floating-wa"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat with AUMHUM on WhatsApp"
      >
        <WhatsappGlyph />
      </a>
      <button
        type="button"
        className="ct-floating-btn ct-floating-phone"
        onClick={onPhoneClick}
        aria-label="Call AUMHUM"
      >
        <PhoneGlyph />
      </button>
    </div>
  )
}

// Inline SVG glyphs — deliberately local so this file stays a single
// drop-in component for any page that wants the floating contact pair.

function WhatsappGlyph() {
  return (
    <svg viewBox="0 0 32 32" width="24" height="24" aria-hidden="true" focusable="false">
      <path
        fill="currentColor"
        d="M16 3C9.383 3 4 8.383 4 15c0 2.455.743 4.742 2.017 6.658L4.1 28.566a1 1 0 0 0 1.235 1.235l6.936-1.942A12.012 12.012 0 0 0 16 27c6.617 0 12-5.383 12-12S22.617 3 16 3zm6.547 16.89c-.285.802-1.66 1.537-2.316 1.59-.617.051-1.402.073-2.262-.143a16.327 16.327 0 0 1-5.35-2.79c-2.23-1.86-3.69-4.17-3.83-4.367-.14-.197-.946-1.257-.946-2.4 0-1.143.6-1.704.812-1.937.213-.232.465-.29.62-.29.155 0 .31 0 .446.006.142.006.333-.053.521.398.197.465.67 1.607.73 1.725.06.118.099.256.02.412-.078.155-.117.251-.232.386-.116.135-.244.3-.349.402-.116.116-.237.243-.102.476.136.233.605.997 1.299 1.615.89.79 1.641 1.034 1.876 1.15.232.117.366.097.501-.058.136-.155.58-.676.735-.908.155-.232.31-.193.522-.116.213.077 1.355.638 1.587.754.232.116.387.174.445.272.058.097.058.561-.227 1.367z"
      />
    </svg>
  )
}

function PhoneGlyph() {
  return (
    <svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" focusable="false">
      <path
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M22 16.92v3a2 2 0 0 1-2.18 2 19.8 19.8 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.8 19.8 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.362 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.338 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"
      />
    </svg>
  )
}
